module.exports = function() {
    this.$store.dispatch(`${this.name}_CHECKBOX/clearSelected`);
};
